import React from 'react';

const CurvyArrowFaqMobile: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="38" height="69" viewBox="0 0 38 69" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.1865 0C11.4026 0.806637 12.5439 1.57495 13.7197 2.38574C23.5596 9.71981 36.4522 17.3687 37.3115 31.6035C36.2617 45.72 24.2779 54.3278 14.749 62.4707C13.7783 63.2463 12.7932 64.0152 11.7715 64.8008L13.8184 68.7529L0 67.7266L7.74219 57.0205L9.92676 61.2393C10.7858 60.6362 11.6226 60.0436 12.4482 59.4463C22.2144 51.9817 33.9551 43.8521 35.3125 31.5498C35.3595 18.9898 23.133 10.2067 13.6025 2.54785C12.4669 1.68386 11.3645 0.861373 10.1865 0Z" fill="#79A5F8"/>
</svg>

);

export default CurvyArrowFaqMobile;
